import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, take } from 'rxjs';
import {
  GroupErrorReportRequest,
  GroupErrorReports,
  LocationErrorReportRequest,
  LocationErrorReports,
} from 'src/app/core/models/reports/error-reports.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorReportsService {
  baseUrl = environment.apiUrl.concat('report-management/');

  constructor(
    private readonly http: HttpClient,
    private readonly commonUtils: CommonUtils,
    private readonly errorHandler: ErrorhandleService,
  ) {}

  /**
   * Get Location Error Report Data
   *
   * @param {string} locationCode
   * @param {string} groupCode
   * @return {*}  {Observable<RetailActivityReport>}
   * @memberof ErrorReportsService
   */
  getLocationErrorReport(
    request: LocationErrorReportRequest,
  ): Observable<LocationErrorReports> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<LocationErrorReports>(this.baseUrl.concat('location-error-report'), {
        params: { ...request },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<LocationErrorReports>(
            error,
            error.status,
            'Report Service: Get Location Error Report',
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   * Get Location Error Report Data
   *
   * @param {string} locationCode
   * @param {string} groupCode
   * @return {*}  {Observable<RetailActivityReport>}
   * @memberof ErrorReportsService
   */
  getGroupErrorReport(
    request: GroupErrorReportRequest,
  ): Observable<GroupErrorReports> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<GroupErrorReports>(this.baseUrl.concat('group-error-report'), {
        params: { ...request },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GroupErrorReports>(
            error,
            error.status,
            'Report Service: Get Group Error Report',
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
